import { useCallback, useRef, useState } from 'react';
import type { PropsWithChildren } from 'react';
import type React from 'react';

import type { EmptyObject } from 'type-fest';

import { useMutationObserver } from 'src/app/shared/hooks/dom';

export const MutationObserverContainer: React.FC<PropsWithChildren<EmptyObject>> = ({ children }) => {
	const mutationRef = useRef(null);
	const [mutationCount, setMutationCount] = useState(0);
	const incrementMutationCount = useCallback(() => {
		return setMutationCount((count) => count + 1);
	}, []);

	useMutationObserver(mutationRef, incrementMutationCount, {
		attributes: true,
		characterData: false,
		childList: false,
		subtree: false,
	});

	return (
		<div data-testid="sap-container" key={mutationCount} ref={mutationRef}>
			{children}
		</div>
	);
};
